import { CSSProperties } from "react";
import dayjs from "dayjs";
import { JobReadinessMaterialLine } from "types/jobReadiness";

export const formatQty = (value: number) =>
  new Intl.NumberFormat("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(
    value || 0
  );

export const formatMoney = (value: number) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value || 0);

export const formatDateLabel = (value: string) => dayjs(value).format("ddd, MMM D");

export const formatChecklistStatus = (checklistTotal: number, checklistOutstanding: number) => {
  if (checklistTotal === 0) {
    return "N/A";
  }

  return `${Math.max(checklistTotal - checklistOutstanding, 0)}/${checklistTotal}`;
};

export const getChecklistPillStyle = (
  checklistTotal: number,
  checklistOutstanding: number
): CSSProperties => {
  if (checklistTotal === 0) {
    return {
      background: "#edf2f7",
      color: "#4a5568",
    };
  }

  return checklistOutstanding > 0
    ? { background: "#ffebee", color: "#b71c1c" }
    : { background: "#e8f5e9", color: "#1b5e20" };
};

export const getConfirmedPillStyle = (confirmedWithClient: boolean): CSSProperties =>
  confirmedWithClient
    ? { background: "#e8f5e9", color: "#1b5e20" }
    : { background: "#ffebee", color: "#b71c1c" };

export const groupBySource = (lines: JobReadinessMaterialLine[]) => {
  return lines.reduce<Record<string, JobReadinessMaterialLine[]>>((acc, line) => {
    if (!acc[line.sourceName]) {
      acc[line.sourceName] = [];
    }
    acc[line.sourceName].push(line);
    return acc;
  }, {});
};
